import FooterPromo from "gatsby-theme-dettol/src/components/FooterPromo/FooterPromo";

import "./FooterPromoOverride.scss";

export default FooterPromo;